export const trainingContentPackagesCapability = 'training.content-packages.v1';
//# sourceMappingURL=training-content-package.capability.js.map